import React, { useState, useEffect } from "react"
import { CardContainer, Thumb, Image, Rating, Info, Title, Date } from "./styled/movieCard"
import { Skeleton } from "../../components"
import { Icon } from "../../components"
import Color from "../../constants/Color"

export default function Card({ children, to, rest }) {
  return (
    <CardContainer to={to} {...rest}>
      {children}
    </CardContainer>
  )
}

Card.Thumb = function CardThumb({ children, rate, rest }) {
  const [color, setColor] = useState("")
  let number = parseInt(rate)
  useEffect(() => {
    if (number < 4) {
      setColor(Color.bad)
    } else if (number > 3.9 && number < 7) {
      setColor(Color.ok)
    } else if (number > 6.9 && number < 8) {
      setColor(Color.great)
    } else if (number > 7.9) {
      setColor(Color.superb)
    }
    // eslint-disable-next-line
  }, [number])
  return (
    <Thumb {...rest} color={color}>
      {children}
    </Thumb>
  )
}

Card.Rating = function CardRating({ rate, count, rest }) {
  const [color, setColor] = useState("")
  const [bgColor, setBgColor] = useState()
  let number = parseInt(rate)
  useEffect(() => {
    if (rate && number < 4) {
      setColor(Color.bad)
      setBgColor(Color.badBg)
    } else if (number > 3.9 && number < 7) {
      setColor(Color.ok)
      setBgColor(Color.okBg)
    } else if (number > 6.9 && number < 8) {
      setColor(Color.great)
      setBgColor(Color.greatBg)
    } else if (number > 7.9) {
      setColor(Color.superb)
      setBgColor(Color.superbBg)
    } else {
      setColor(Color.white)
    }

    // eslint-disable-next-line
  }, [number])

  return (
    <Rating {...rest} bg={bgColor} count={count} color={color}>
      {count ? "" : <Icon name="ph-star-fill" pt="1" mr="4" color={color} />}
      <p>{rate === 0 ? "0.0" : parseFloat(rate).toFixed(1)}</p>
    </Rating>
  )
}

Card.Image = function CardImage({ path, rest }) {
  return <Image src={path} {...rest} />
}

Card.Info = function CardInfo({ children, isTv, rest }) {
  return (
    <Info {...rest} isTv={isTv}>
      {children}
    </Info>
  )
}

Card.Title = function CardTitle({ children, rest }) {
  return <Title {...rest}>{children ? children : <Skeleton.Title />}</Title>
}

Card.Date = function CardDate({ children, rest }) {
  return <Date {...rest}>{children}</Date>
}
